import { createContext } from 'react';
export const SimpleBlockContext = /*#__PURE__*/createContext({
  size: null,
  contentHeight: null,
  alignment: null
});